import React from "react";

import styled from "styled-components";

import Icon from "components/atoms/Icon";
import Tooltip from "components/atoms/Tooltip";

const Rail = styled.aside`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    width: 40px;
    padding: 8px 4px;
    border-left: 1px solid #d3dde8;
    background: #eef3f7;
`;

const RailTop = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
`;

const RailDivider = styled.div`
    width: 20px;
    height: 1px;
    margin: 4px 0;
    background: #ced8e3;
`;

const RailButton = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border: 1px solid ${(props) => (props.$active ? "#0f8f6f" : "transparent")};
    border-radius: 8px;
    background: ${(props) => (props.$active ? "#e4faf1" : "transparent")};
    cursor: pointer;

    &:hover {
        background: ${(props) => (props.$active ? "#e4faf1" : "#e4ebf2")};
    }
`;

function ManuscriptRightRail({ activePanel, onSelect }) {
    return (
        <Rail>
            <RailTop>
                <RailButton
                    type="button"
                    aria-label="PDF"
                    $active={activePanel === "pdf"}
                    onClick={() => onSelect("pdf")}
                >
                    <Tooltip message="PDF" position="left">
                        <Icon name={"pdf"} size={"16px"} color={activePanel === "pdf" ? "#0f8f6f" : "#6a7f97"} />
                    </Tooltip>
                </RailButton>
                <RailButton
                    type="button"
                    aria-label="히스토리"
                    $active={activePanel === "history"}
                    onClick={() => onSelect("history")}
                >
                    <Tooltip message="히스토리" position="left">
                        <Icon name={"last"} size={"16px"} color={activePanel === "history" ? "#0f8f6f" : "#6a7f97"} />
                    </Tooltip>
                </RailButton>
                <RailDivider />
                <RailButton
                    type="button"
                    aria-label="리뷰"
                    $active={activePanel === "review"}
                    onClick={() => onSelect("review")}
                >
                    <Tooltip message="리뷰" position="left">
                        <Icon name={"thread"} size={"16px"} color={activePanel === "review" ? "#0f8f6f" : "#6a7f97"} />
                    </Tooltip>
                </RailButton>
            </RailTop>
        </Rail>
    );
}

export default ManuscriptRightRail;
